
export default {
    name: "currency-field",
    data () {
        return {
            data: "",
        }
    },
    props: {

        /**
         *
         */
        fieldProps: {
            type: Object,
            default: () => ({})
        },

        /**
         *
         */
        value: [Number, String],
    },
    methods: {

        /**
         *
         */
        reset () {
            this.data = this.value
        }
    },
    mounted () {
        this.reset()
    },
    watch: {

        /**
         *
         */
        data () {
            this.$emit("input", this.data)
        },

        /**
         *
         */
        value () {
            this.reset()
        }
    },
}